<div class="card" [ngClass]="[isSelected ? 'selected' : 'unselected', system.group == 'Process' ? 'process' : 'utility']">
  <div class="content">
    <div class="title">{{ system.name }}</div>
    <div title="{{ system.description }}" class="description">{{ system.description }}</div>
  </div>

  <app-separator></app-separator>

  <div class="footer">
    <button class="iconf-btn-blank" (click)="isSelected ? removeSystem.emit(system) : selectSystem.emit(system)">
      <mat-icon class="mat-icon-blue">{{ isSelected ? 'remove' : 'add' }}</mat-icon>
      <span>{{ isSelected ? 'remove' : 'select' }}</span>
    </button>
  </div>
</div>
